// Bridges a generated report PDF's URL out to the native React Native app
// that embeds these webview report pages, so the app can offer a native
// share sheet instead of the page opening/downloading the PDF itself.
//
// A WebView page can only get data out to its native host two ways:
//   1. window.ReactNativeWebView.postMessage — needs the native
//      <WebView onMessage={...}> handler wired up on the app side.
//   2. The page's own URL — the native side commonly tracks this via a
//      navigation-state listener, with no extra wiring needed.
// The mobile team confirmed only #2 is wired today, so we push the PDF url
// onto the current page's URL as a query param (via history.replaceState,
// so it doesn't add a back-history entry) as the channel guaranteed to
// work, and also fire the postMessage for whenever onMessage gets wired.
// The query param is set unconditionally (not just inside the WebView) so
// it's already in the URL by the time the app's navigation-state listener
// looks for it — it never depends on the user clicking Share first.
export const notifyNativeApp = (pdfUrl, title = "Report") => {
  if (!pdfUrl) return;
  const fileName = pdfUrl.split("/").pop();

  if (window.ReactNativeWebView) {
    try {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "SHARE_PDF",
          payload: { url: pdfUrl, fileName, title },
        })
      );
    } catch (error) {
      // postMessage isn't available/wired on the native side yet — the
      // query-param channel below is the fallback that's confirmed working.
    }
  }

  try {
    const url = new URL(window.location.href);
    url.searchParams.set("pdfUrl", pdfUrl);
    url.searchParams.set("pdfFileName", fileName);
    window.history.replaceState(null, "", url.toString());
  } catch (error) {
    // Ignore — nothing more we can do to reach the native host.
  }
};

// Click handler for the "Share PDF" button. It only hands the url to the
// native host (see notifyNativeApp above) — it never opens or downloads the
// PDF itself, on any platform. The native app watches the query param and
// handles the actual share/download on its own side.
export const sharePdf = (pdfUrl, title = "Report") => {
  notifyNativeApp(pdfUrl, title);
};
